import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { I18nService } from '@gruposaltaedu/liv-i18n/core';

import { LivPortfolioErrorResponse } from '../../models/liv-portfolio-response-protocol.model';
import {
  getRemoteError,
  translateRemoteError
} from '../helpers/get-remote-error';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private readonly i18n = inject(I18nService);

  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return this.i18n.instant('messages.noInternetConnection') as string;
    }
    return error.message ? error.message : JSON.stringify(error);
  }

  getClientStack(error: Error): string {
    return error.stack;
  }

  getServerMessage(
    error: HttpErrorResponse | LivPortfolioErrorResponse
  ): string {
    const remote = translateRemoteError(
      getRemoteError(error, {
        translate: (key) => this.i18n.instant(key) as string
      }),
      this.i18n
    );

    return remote.message;
  }

  getServerStack(error: HttpErrorResponse | LivPortfolioErrorResponse): string {
    if (error instanceof HttpErrorResponse) {
      return '';
    }

    return JSON.stringify(error.error?.details ?? {});
  }
}
